import styled from 'styled-components';
import device from '../mediaQueries';

export const ContentWrapper = styled.div`
  background: ${({ background }) => background || 'white'};
  position: relative;
  text-align: center;
  vertical-align: middle;
  border-color: #000;
  border-radius: 5px;
  ${device.desktop`
    width: ${({ width }) => width || '604px'};
    height: ${({ desktopHeight, height }) => desktopHeight || height || '305px'};
  `}
  ${device.mobile`
    width: ${({ width }) => width || '320px'}
    height: ${({ mobileHeight, height }) => mobileHeight || height || '305px'};
  `}
`;

export const ContentContainer = styled.div`
  background: ${({ background }) => background || 'rgba(255, 255, 255, 1)'};
  border-radius: 5px;
  border: ${({ border }) => border || '1px solid #000000'};
  left: 9px;
  top: 9px;
  z-index: 1;
  height: 100%;
  margin-bottom: 9px;
  position: absolute;
  ${device.desktop`
    width: ${({ width }) => width || '583px'};
    height: ${({ desktopHeight, height }) => desktopHeight || height || '285px'};
  `}
  ${device.mobile`
    width: ${({ width }) => width || '300px'}
    height: ${({ mobileHeight, height }) => mobileHeight || height || '285px'};
  `}
`;

export const LinkButton = styled.a`
  font-family: 'Avenir Black', 'Arial Black', sans-serif;
  display: flex;
  justify-content: center;
  align-content: center;
  flex-direction: column;
  border-style: none;
  border-radius: 5px;
  width: 340px;
  height: 44px;
  max-width: 90%;
  background: rgba(0, 0, 0, 1);
  color: #ffffff;
  cursor: pointer;
  &:hover {
    color: white;
    text-decoration: none;
  }
  ${device.desktop`
      margin: ${({ margin }) => margin || 'auto auto 16px auto'};
  `}
  ${device.mobile`
      margin: ${({ margin }) => margin || 'auto auto 8px auto'};
  `}
`;

export const Link = styled.a`
  text-decoration: underline;
`;

export const InputField = styled.input`
  border-style: solid;
  border-width: 1px;
  border-color: #999999;
  background-color: #fff;
  color: black;
  border-radius: 5px;
  box-shadow: inset 0px 2px 3px #dddddd;
  height: 46px;
  width: 340px;
  font-size: 15px;
  line-height: 15px;
  padding: 14px;
  margin-bottom: 16px;
`;

export const SmallText = styled.p`
  font-size: 14px;
`;

export const Text = styled.p`
  color: black;
  font-size: ${({ fontSize }) => fontSize || '24px'};
  line-height: 26px;
  font-family: 'Avenir Light', 'Arial', sans-serif;
  font-weight: 300;
  width: 425px;
  max-width: 95%;
  margin: 24px auto;
`;

export const EmphasizedTextRed = styled.span`
  font-weight: 900;
  font-family: 'Avenir Black', 'Arial Black', sans-serif;
  line-height: 26px;
  font-size: 24px;
  color: rgb(255, 0, 0);
`;

export const EmphasizedHeader = styled.div`
  font-family: 'Avenir Black', 'Arial Black', sans-serif;
  line-height: initial;
  font-size: ${({ fontSize }) => fontSize || '28px'};
  font-weight: 900;
`;

export const CloseButton = styled.button`
  font-weight: 400;
  border: 0;
  border-radius: 50%;
  color: #525151;
  cursor: pointer;
  font-family: 'Arial', sans-serif;
  font-size: 20px;
  font-weight: 400;
  height: 20px;
  line-height: 1;
  outline: none;
  padding: 0;
  position: absolute;
  top: 0px;
  right: 0px;
  text-align: center;
  transition: transform 0.2s ease-in-out, background-color 0.2s ease-in-out;
  background-color: initial;
  width: 20px;
  z-index: 1;
`;
